import React, { Component } from 'react'
import PropTypes from 'prop-types'
import querystring from 'querystring'
import '../App.css'
import SearchHeader from '../components/SearchHeader'
import Footer from '../components/Footer'
import Result from '../components/Result'

class Search extends Component {
  componentDidUpdate() {
    //console.log('Search component did update.')
  }
  getSearchTerm() {
    return querystring.parse(this.context.router.route.location.search)['?q']
  }
  searchExists(urlSearchTerm) {
    let originalTerms = this.props.searches.map(function (search){
      return search.searchTerm
    })
    let compareTerms = originalTerms.map( function(term) {
      return term.toLowerCase()
    })
    let urlTermLowercase = urlSearchTerm.toLowerCase()
    let theIndex = compareTerms.indexOf(urlTermLowercase)
    if (theIndex > -1 
        && this.props.searches[theIndex].results.length) {
          return theIndex
        }
        return false
  }
  renderResults() {
    let urlSearchTerm = this.getSearchTerm()
    if (!urlSearchTerm) {
      return (<h2>No valid search term</h2>)
    }
    let goodSearch = this.searchExists(urlSearchTerm)
    if (goodSearch !== false) {
      let searchResults = []
      let originalTerms = Object.keys(this.props.searches)
      let results = this.props.searches[originalTerms[goodSearch]].results
      for (let i = 0; i < results.length; i++) {
        searchResults.push(<Result key={results[i].id} headline={results[i].title} url={results[i].link} descr={results[i].descr} />)
      }
      return (searchResults)
    } else {
      return (<h2>No results</h2>)
    }
  }
  render() {
    return (
      <div className="main">
        <SearchHeader currentSearch={this.props.currentSearch} updateSearch={this.props.updateSearch} doSearch={this.props.doSearch} />
        <div className="container search">
          { this.renderResults() }
        </div>
        
        <Footer />
      </div>
    );
  }
}

Search.contextTypes = {
  router: PropTypes.object
}

export default Search


// WEBPACK FOOTER //
// ./src/pages/Search.js